import { connect } from "react-redux";

import MessageTray from "components/MessageTray";
import { selectMessage } from "selector/messageSelectors";

export const mapStateToProps = state => {
  return {
    message: selectMessage(state)
  };
};

const MessageTrayContainer = connect(mapStateToProps)(MessageTray);

export default MessageTrayContainer;
